export default (function (Component) { return function (c) {
    // React Component
    if (c.type === Component) {
        return true;
    }
    // Matching componentType
    if (c.props && c.props.componentType === Component) {
        return true;
    }
    return false;
}; });
//# sourceMappingURL=matchComponent.js.map